import { Record } from 'immutable';
import { IMAGE_UPLOAD_SUCCESSFUL, IMAGE_UPLOAD_FAILURE } from './action-types';

export const ImageUploaderState = new Record({
  url: '',
  error:''
});

export function imageUploadReducer(state = new ImageUploaderState(), upload) {
  switch(upload.type) {
    case IMAGE_UPLOAD_SUCCESSFUL:
      return state.merge({
        url: upload.url
      })

    case IMAGE_UPLOAD_FAILURE:
      return state.merge({
        error: upload.error
      })

    default:
      return new ImageUploaderState();

  }
}



// WEBPACK FOOTER //
// ./src/image-uploader/reducer.js